const debug = process.env.NODE_ENV === "development";

export default {
  serverPath: `${debug ? `http://${window.location.hostname}` : ""}/luci/`,
  camioServer: `${debug ? `http://${window.location.hostname}` : ""}/`,
  camioApiUrl: `${
    debug ? `http://${window.location.hostname}` : ""
  }/CamioApi/api/`,
  credentialManagerPath: `http://${window.location.hostname}:8181`,
  streamServer: window.location.origin,
  useHiResThumbnails: false,
  feedPollingRate: 10000,
  socialMediaIntegrations: {
    twitter: true,
    facebook: true,
    instagram: false
  },
  enableClipper: false,
  enableThemes: false,
  stateSaveDelay: 5000
};



// WEBPACK FOOTER //
// ./app/settings.js